import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal, Input, message } from 'antd';
import {
  _change_confirm_room_pwd_modal,
  _new_room_window,
} from '../../store/Action';
import HTTP from '../../script/service';
import './index.scss';

// 连续输错次数
const COUNT_PASSWD = 5;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      ps: '',
    };
  }
  shouldComponentUpdate(newProps, newState) {
    if (
      this.props.base.confirmRoomPwd === false &&
      newProps.base.confirmRoomPwd
    ) {
      setTimeout(() => {
        this.pwdElement && this.pwdElement.focus();
      }, 500);
    }
    return true;
  }
  hideModal = (e) => {
    _change_confirm_room_pwd_modal(false);
    this.setState({ loading: false, ps: '' });
  };

  toSubmit = () => {
    if (this.state.loading) return;
    const { ps } = this.state;
    const { confirmRoomPwd } = this.props.base;
    if (!ps || ps.toString().length !== 4 || isNaN(ps)) {
      message.warning('请正确输入房间密码：4位数字或字符');
      return;
    }
    this.setState({ loading: true }, () => {
      HTTP._if_room_password({
        roomid: confirmRoomPwd,
        password: ps,
      }).then((res) => {
        if (res?.code === 200) {
          const inputTimes = res?.data.passwordNum || 0;
          if (inputTimes >= 5) {
            this.hideModal();
          } else {
            const count = inputTimes ? inputTimes - COUNT_PASSWD : 0;
            // eslint-disable-next-line no-mixed-operators
            if (
              res.data.ifRoomPasswordTrue ||
              (res.data.ifRoomPassword == false && count <= 0)
            ) {
              localStorage.setItem('pwd_' + confirmRoomPwd, ps);
              _new_room_window(
                {
                  roomid: confirmRoomPwd,
                  password: ps,
                },
                this.props.history
              );
              this.hideModal();
            } else {
              this.errorPwd();
            }
          }
        } else {
          this.errorPwd(res?.message || '');
        }
      });
    });
  };
  errorPwd = (msg) => {
    msg = msg || '密码验证失败';
    message.error(msg);
    this.setState({ loading: false, ps: '' }, () => {
      this.pwdElement && this.pwdElement.focus();
    });
  };
  render() {
    const { loading, ps } = this.state;
    const { confirmRoomPwd } = this.props.base;
    return (
      <Modal
        open={!!confirmRoomPwd}
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        title="房间密码验证"
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="420px"
        onCancel={this.hideModal}
        getContainer={false}
        zIndex={2000}
      >
        <div className="room-pwd-confirm">
          <div className="c-title">输入密码</div>
          <div className="c-title-label">房间已加密，需要密码才能加入</div>
          <div className="input-row">
            <Input.OTP
              ref={(el) => (this.pwdElement = el)}
              value={ps}
              length={4}
              formatter={(val) => val.replace(/\D/g, '')}
              onInput={(val) => {
                this.setState({ ps: val.join('') }, () => {
                  if (this.state?.ps?.length === 4) {
                    this.toSubmit();
                  }
                });
              }}
            />
          </div>
          <div className="submit-row">
            <button
              className={
                loading ? 'daidai-btn-primary disable' : 'daidai-btn-primary'
              }
              disabled={loading}
              onClick={this.toSubmit}
            >
              进入房间
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
